module.exports = __webpack_public_path__ + "fonts/SFProText-Bold.dcb8aacf.woff";